import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Dialog, DialogBody } from '../../common/components/Modal/Modal';
import { ProjectForm } from '../components/ProjectForm';
import { Project } from '../models/Project';
import { ProjectService } from '../services/ProjectService';

type Props = {
  project: Project;
  hasUnlimitedReports?: boolean;
  onClosed: (projectId: number | undefined) => void;
};

export const UpdateProjectFlow = ({ project, hasUnlimitedReports = false, onClosed }: Props) => {
  // It's not a preference to have services in states, but we use it here so
  // that we can leverage same service in multiple functionalities.
  const [projectService] = useState<ProjectService>(new ProjectService());

  useEffect(() => {
    return () => {
      projectService.cancelAllRequests();
    };
  }, [projectService]);

  return (
    <Dialog title={t('updateProject.title')} subtitle={t('updateProject.subtitle')} onDismiss={() => onClosed(undefined)}>
      <DialogBody>
        <ProjectForm
          unlimitedReports={hasUnlimitedReports}
          prefill={{
            name: project.getName(),
            description: project.getDescription(),
            profileId: project.getDefaultProfile()?.getId() || null,
            maxItemCount: project.getMaxItemCount(),
          }}
          submit={{
            label: t('updateProject.submit'),
            action: (name, description, _, maxItemCount) =>
              projectService.updateProject(project.getId(), name, description, maxItemCount).then((p) => onClosed(p.getId())),
          }}
          back={{ label: t('updateProject.back'), action: () => onClosed(undefined) }}
        />
      </DialogBody>
    </Dialog>
  );
};
